'use client';

import { useEffect, useRef } from 'react';
import { mountHeroPipeline } from './mountHeroPipeline';

type Props = {
  reducedMotion: boolean;
};

export default function HeroPipeline({ reducedMotion }: Props) {
  const ref = useRef<SVGSVGElement>(null);

  useEffect(() => {
    const svg = ref.current;
    if (!svg) return;
    return mountHeroPipeline(svg, reducedMotion);
  }, [reducedMotion]);

  return (
    <div className="hero-pipeline">
      <svg
        ref={ref}
        viewBox="0 0 640 560"
        role="img"
        aria-label="Ideas, problems and opportunities enter the Creator Tech engine and leave as finished web, mobile, SaaS and AI products."
      />
    </div>
  );
}
